import React from 'react';
import { connect } from 'react-redux';
import { states } from '@/constants/lifecycle';
import { presentationOptions } from '@/constants/states';
import paging, { onCategoryScroll } from '@/hooks/paging';
import CardsHeader from '@/components/cards/CardsHeader';
import SearchesTable from '../components/SearchesTable';
import SearchesPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/SearchesPanelContainer';
import SearchesFilters from './SearchesFilters';
import SearchCards from '../components/SearchCards';

const SearchesPanelFull = ({
  category,
  canRead,
  currentPage,
  display,
  fetchData,
  pageCount,
  onCheckBoxClick,
  pageSize,
  searches,
  readErrors,
  readStatus,
  togglePresentation,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus);
  return (
    <SearchesPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-searches-panel-full">
      {display === presentationOptions.CARDS && (
      <>
        <CardsHeader
          disabled={readStatus === states.PENDING}
          onClick={() => togglePresentation(category, presentationOptions.TABLE)}
        >
          <SearchesFilters category={category} className="aridhia-list-filter" />
        </CardsHeader>
        <SearchCards
          category={category}
          handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
          items={searches}
          onCheckBoxClick={onCheckBoxClick}
          readErrors={readErrors}
          readStatus={readStatus}
        />
      </>
      )}
      {display !== presentationOptions.CARDS && (
      <SearchesTable
        category={category}
        currentPage={currentPage}
        fetchData={fetchData}
        onCheckBoxClick={onCheckBoxClick}
        pageCount={pageCount}
        pageSize={pageSize}
        searches={searches}
        readErrors={readErrors}
        readStatus={readStatus}
        togglePresentation={togglePresentation}
        total={total}
      />
      )}
    </SearchesPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchesPanelFull);
